import React, { useEffect } from 'react';
import "./GallerySliderNew.scss";
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, A11y, Thumbs } from 'swiper';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/swiper.scss';
import { PrevArrow, NextArrow } from './arrows';
import { useState } from 'react';

function GallerySliderNew(props) {
    var [mainSwiper, setMainSwiper] = useState(null);
    var [mobileThumbsSwiper, setMobileThumbsSwiper] = useState(null);
    var [thumbsSwiper, setThumbsSwiper] = useState(null);

    var [swiperInitStatus, setSwiperInitStatus] = useState(window.innerWidth > 1024);

    function nextSlide() {
        mainSwiper.slideNext();
        thumbsSwiper.slideNext();
    }

    function prevSlide() {
        mainSwiper.slidePrev();
        thumbsSwiper.slidePrev();
    }

    function initSwiper() {
        setSwiperInitStatus(window.innerWidth > 1024);
    }
    
    useEffect(() => {
        window.addEventListener('resize', initSwiper);

        return () => {
            window.removeEventListener('resize', initSwiper);
        };
    });
    

    return (
        <div className='gallery-slider-new '>
            <Swiper
                slidesPerView={1}
                className='gallery-swiper'
                modules={[Thumbs]}
                onSwiper={setMainSwiper}
                thumbs={{swiper: thumbsSwiper}}
            >
                {props.renderings && props.renderings.map((rendering, key) => (
                    <SwiperSlide key={key}>
                        <div className='slide-container'>
                            <div className='caption'>{rendering.label}</div>
                            <div className='slide-image'>
                                <img
                                    className=''
                                    src={rendering.image.url}
                                    alt={rendering.image.alt}
                                />
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            <div className='buttons'>
                <button className='prev-button' onClick={() => prevSlide()}>
                    <PrevArrow />
                </button>
                <button className='next-button' onClick={() => nextSlide()}>
                    <NextArrow />
                </button>
            </div>
            <Swiper
                slidesPerView={initSwiper ? 8 : 2}
                spaceBetween={8}
                modules={[Thumbs]}
                watchSlidesProgress
                onSwiper={setThumbsSwiper}
                className='thumb-swiper'
            >
                {props.renderings && props.renderings.map((rendering, key) => (
                    <SwiperSlide key={key}>
                        <div className='thumb-container'>
                            <div className='dot'>
                                
                            </div>
                            <img className='thumb-image' src={rendering.image.url} />
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    )
}

export default GallerySliderNew;